import { Divider, Wrapper, useMediaQuery, Text } from '@lounge-fe/ui-kit'
import type { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { PaymentProviders } from './PaymentProviders'
import { Copyright } from './Copyright'
import { MainMenu } from './MainMenu'
import { FooterData } from './types'
import { PolicyMenu } from './PolicyMenu'
import { NewsletterSignup } from './NewsletterSignup'
import { SocialLinks } from './SocialLinks'
import { CountrySelector } from './CountrySelector/CountrySelector'
import { isHomepage } from '@/utils'

const Footer: ShopifySectionComponent<FooterData> = ({
  data: {
    main_menu = [],
    policy_menu = [],
    payment_providers,
    social_urls,
    newsletter,
    seo_content,
  } = {},
}) => {
  const isMobile = useMediaQuery(({ screens }) => `(max-width: ${screens.lg})`)
  return (
    <Wrapper size="fluid" className="pt-4 lg:pt-12">
      <div className="flex flex-col-reverse gap-x-4 gap-y-6 lg:flex-row-reverse lg:justify-between">
        <div className="flex flex-col lg:basis-[432px]">
          {newsletter && (
            <NewsletterSignup data={newsletter} className="lg:mb-20" />
          )}
          {isHomepage ? (
            <>
              {seo_content?.title && !isMobile && (
                <Text as="h1" variant="title-six">
                  {seo_content.title}
                </Text>
              )}
              {seo_content?.body && !isMobile && (
                <div
                  dangerouslySetInnerHTML={{ __html: seo_content.body }}
                  className="hidden"
                />
              )}
            </>
          ) : undefined}
        </div>
        <MainMenu menus={main_menu} SEOContent={seo_content} />
      </div>
      <div className="flex flex-col-reverse gap-y-6 lg:flex-row lg:justify-between mt-4 lg:mt-12">
        {payment_providers && !isMobile && (
          <PaymentProviders paymentProviders={payment_providers} />
        )}
        <PolicyMenu menu={policy_menu} className="block lg:hidden" />
        {social_urls && <SocialLinks socialUrls={social_urls} />}
      </div>
      <Divider className="mt-4 !border-[#E7E7E7] hidden lg:block" />
      <div className="flex flex-wrap pt-6 pb-8 flex-col lg:flex-row lg:justify-between lg:items-center gap-x-4 gap-y-2">
        <div className="flex gap-4">
          <CountrySelector />
          <Copyright />
        </div>
        <PolicyMenu className="hidden lg:block" menu={policy_menu} />
      </div>
    </Wrapper>
  )
}

export default Footer
